import {Card, CardContent, CardHeader} from "@/components/ui/card.tsx";
import {cn} from "@/lib/utils.ts";
import {Button} from "@/components/ui/button.tsx";
import axios from "axios";
import {useEffect, useState} from "react";

import logo from "@/assets/logo_fekvo_feher.svg";
import {PlusIcon} from "lucide-react";
import {useNavigate} from "react-router";


function Dashboard() {

    const navigate = useNavigate()
    const [data, setData] = useState<null|any[]>(null)

    useEffect(() => {
        axios.get("/api/dashboard").then((res) => {
            setData(res.data)
        })
    }, []);

    return (
        <div className={"px-4"}>
            <div className={'flex justify-end mb-4'}>
                {/*<Input className={"max-w-1/2"} prefix={"sad"} placeholder={"Keresés a Portálon"} readOnly></Input>*/}
                <Button onClick={() => {
                    axios.post(`/api/documents`).then(res => {
                        navigate(`/documents/${res.data.id}/edit`)
                    })
                }}><PlusIcon/>Új tanulmány</Button>
            </div>
            <div className={"grid grid-cols-6 gap-3"}>
                {data?.map(data => (
                    <Card className={"w-full col-span-2"}>
                        {data.type === 'stat' ?
                            <CardContent>
                                <div className={"text-3xl font-black text-center"}>{data.value}</div>
                                <div className={cn(
                                    "text-xs font-semibold text-muted-foreground text-center mb-4",
                                    ((data?.trend ?? 0) > 0) && "text-constructive font-bold"
                                )}>{((data?.trend ?? 0) > 0) && "+"}{data.trend}{data.trend_sign}</div>
                                <p className={"text-center"}>{data.title}</p>
                                <p className={"text-center"}>{data.interval}</p>
                            </CardContent> :
                            <div className={"text-center text-muted-foreground my-auto"}>
                                Hamarosan új funkcóval bővül..
                            </div>
                        }

                    </Card>
                ))}

                <Card className={"w-full pt-0 col-span-3"}>
                    <CardHeader className={"bg-sidebar text-sidebar-foreground py-6 rounded-t-xl flex justify-center"}>
                        <img src={logo} className={"h-20"} alt={"Logo"}/>

                    </CardHeader>
                    <CardContent>
                        <p className={"font-bold"}>
                            Üdvözöljük a Vállalati Stratégia Portálon!
                        </p>
                        <p>
                            Üdvözöljük a Vállalati Stratégia Portálon! Kezdhetjük a munkát! Új tanulmány létrehozásához
                            válassza a Tanulmányok - Új tanulmány menüpontot.
                        </p>
                    </CardContent>
                </Card>
                <Card className={"w-full col-span-3"}>
                    <div className={"text-center text-muted-foreground my-auto"}>
                        Hamarosan új funkcóval bővül..
                    </div>
                </Card>
            </div>


        </div>
    );
}

export default Dashboard;